var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(79 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82 231)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M325.674,259.13h-.2v-1.174a1.956,1.956,0,0,0-3.913,0v1.174h-.2A1.371,1.371,0,0,0,320,260.5v2.739a1.371,1.371,0,0,0,1.37,1.37h4.3a1.371,1.371,0,0,0,1.37-1.37V260.5A1.371,1.371,0,0,0,325.674,259.13Zm-2.935-1.174a.783.783,0,0,1,1.565,0v1.174h-1.565Zm0,0",
    transform: "translate(-308.261 -246.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.565,260.5a2.548,2.548,0,0,1,1.565-2.348v-.2a3.094,3.094,0,0,1,.306-1.327A3.7,3.7,0,0,0,10.37,256H3.717A3.722,3.722,0,0,0,0,259.717v2.739a.587.587,0,0,0,.587.587h9.978Zm0,0",
    transform: "translate(0 -246.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.158,3.913A3.913,3.913,0,1,1,89.245,0,3.913,3.913,0,0,1,93.158,3.913Zm0,0",
    transform: "translate(-82.202)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessManagement);
export default __webpack_public_path__ + "static/media/accessManagement.6cf7c9e5b5bc385e50e2a27a92c2edca.svg";
export { ForwardRef as ReactComponent };